import React from "react"

import classNames from "classnames"

import { FormOverlay } from "shared/ui/overlay/FormOverlay"

import { ProductPositionFormModel } from "features/product-position-management/types/ProductPositionFormModel"
import { ProductPositionForm } from "widgets/product-position/product-position-form/ProductPositionForm"

export interface ProductPositionOverlayViewModel {
  id: string
  headline: string
  submitButtonText?: string
  prefix?: string
  autoFocus?: boolean
  className?: string
  isLoading?: boolean
  isSubmitting?: boolean
  onClose: () => void

  productPositionFormModel: ProductPositionFormModel
}

export const ProductPositionOverlay = React.memo(
  ({
    id,
    headline,
    submitButtonText,
    onClose,
    prefix,
    autoFocus = true,
    className,
    isLoading,
    isSubmitting,
    productPositionFormModel
  }: ProductPositionOverlayViewModel) => {
    // Submitting before the permissions are known would fail server-side, so
    // the form and its actions stay disabled until they resolve.
    const isDisabled =
      isSubmitting || productPositionFormModel.isLoadingPermissions

    return (
      <FormOverlay
        id={id}
        prefix={prefix}
        headline={headline}
        submitButtonText={submitButtonText}
        onCancel={onClose}
        form={productPositionFormModel.id}
        className={classNames("product-position-overlay", className)}
        isLoading={isLoading}
        isSubmitDisabled={isLoading || isDisabled}
        isDisabled={isDisabled}
        showCloseButton
      >
        <ProductPositionForm
          {...productPositionFormModel}
          autoFocus={autoFocus}
          isDisabled={isDisabled}
          className="overlay-form"
        >
          <ProductPositionForm.Tabs />
        </ProductPositionForm>
      </FormOverlay>
    )
  }
)
